import type { PaginationMeta } from '@/types/shared'

export function usePaginationVM(meta: PaginationMeta) {
  const { currentPage, totalPages, totalCount, perPage } = meta

  const shouldRender = totalPages > 1

  const from = (currentPage - 1) * perPage + 1
  const to = Math.min(currentPage * perPage, totalCount)

  const pages = Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
    if (totalPages <= 5) return i + 1
    if (currentPage <= 3) return i + 1
    if (currentPage >= totalPages - 2) return totalPages - 4 + i
    return currentPage - 2 + i
  })

  const hasPrevious = currentPage > 1
  const hasNext = currentPage < totalPages
  const previousPage = currentPage - 1
  const nextPage = currentPage + 1

  return {
    shouldRender,
    from,
    to,
    totalCount,
    pages,
    currentPage,
    hasPrevious,
    hasNext,
    previousPage,
    nextPage,
  }
}
